import React, { FC, useEffect, useState } from "react"
import { useSelector } from "react-redux"

import {
  canEdit,
  getFormsEditable,
  getSectionFieldNames,
  getSettings,
} from "@/onboarding/features/product/selectors"
import Edit from "./overview/Edit"
import Content from "./overview/Content"
import EditIcon from "../shared/EditIcon"

const Overview: FC = () => {
  const editable = useSelector(canEdit)
  const formsEditable = useSelector(getFormsEditable)
  const editingInitialState = formsEditable
  const showEditIcon = editable
  const [editing, setEditing] = useState(editingInitialState)

  const fieldNames = useSelector(getSectionFieldNames.tourLocation)
  const fieldsSettings = useSelector(getSettings(...fieldNames))
  const hasChangedFields = fieldNames.some((fieldName) => fieldsSettings[fieldName]?.changed)
  const labelStyle = hasChangedFields ? "yellow-underline" : ""

  const [showPrevious, setShowPrevious] = useState(false)

  const toggleShowPrevious = () => {
    if (hasChangedFields) {
      setShowPrevious((prev) => !prev)
    }
  }

  useEffect(() => {
    if (editing !== formsEditable) {
      setEditing(formsEditable)
    }
  }, [formsEditable])

  return (
    <div>
      <div className="d-flex justify-content-between">
        <div className="d-flex align-items-end gap-1">
          <h3 className="h5 mb-0" onClick={toggleShowPrevious}>
            Overview
          </h3>
          {showPrevious && <small className="text-muted fst-italic">Showing Original Values</small>}
        </div>
        {showEditIcon && !editing && <EditIcon onEdit={() => setEditing(true)} />}
        {editing && (
          <span className="cursor-pointer" onClick={() => setEditing(false)}>
            <i className="fas fa-times text-danger" />
          </span>
        )}
      </div>
      {editing ? <Edit setEditing={setEditing} /> : <Content />}
    </div>
  )
}

export default Overview
